var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 25,
    viewBox: "0 0 322 25",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 9.45276)",
    fill: "#2F80ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12514,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37798e-08 1 1 4.36431e-08 0 0.0307007)",
    fill: "#2F80ED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 18.8748)",
    fill: "#2F80ED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 95.5137 9.45276)",
    fill: "#2F80ED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 105.065 9.45276)",
    fill: "#2F80ED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 114.616 9.45276)",
    fill: "#2F80ED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 124.167 9.45276)",
    fill: "#2F80ED"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 133.719 9.45276)",
    fill: "#2F80ED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 162.373 9.45276)",
    fill: "#2F80ED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 143.27 9.45276)",
    fill: "#2F80ED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 171.924 9.45276)",
    fill: "#2F80ED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 152.822 9.45276)",
    fill: "#2F80ED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 181.475 9.45276)",
    fill: "#2F80ED"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 95.5137 18.8748)",
    fill: "#2F80ED"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 105.065 18.8748)",
    fill: "#2F80ED"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 114.616 18.8748)",
    fill: "#2F80ED"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 124.167 18.8748)",
    fill: "#2F80ED"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 133.719 18.8748)",
    fill: "#2F80ED"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 162.373 18.8748)",
    fill: "#2F80ED"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 143.27 18.8748)",
    fill: "#2F80ED"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 171.924 18.8748)",
    fill: "#2F80ED"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 152.822 18.8748)",
    fill: "#2F80ED"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 181.475 18.8748)",
    fill: "#2F80ED"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 28.6541 9.45276)",
    fill: "#2F80ED"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 38.2051 9.45276)",
    fill: "#2F80ED"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 66.8591 9.45276)",
    fill: "#2F80ED"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 47.7566 9.45276)",
    fill: "#2F80ED"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 76.4109 9.45276)",
    fill: "#2F80ED"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 57.3081 9.45276)",
    fill: "#2F80ED"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 85.9622 9.45276)",
    fill: "#2F80ED"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12514,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37798e-08 1 1 4.36431e-08 28.6538 0.0307007)",
    fill: "#2F80ED"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12514,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37798e-08 1 1 4.36431e-08 38.2053 0.0307007)",
    fill: "#2F80ED"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12514,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37797e-08 1 1 4.36431e-08 47.7566 0.0307007)",
    fill: "#2F80ED"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 28.6541 18.8748)",
    fill: "#2F80ED"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 38.2051 18.8748)",
    fill: "#2F80ED"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 66.8591 18.8748)",
    fill: "#2F80ED"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 47.7566 18.8748)",
    fill: "#2F80ED"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 76.4109 18.8748)",
    fill: "#2F80ED"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 57.3081 18.8748)",
    fill: "#2F80ED"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 85.9622 18.8748)",
    fill: "#2F80ED"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 9.55127 9.45276)",
    fill: "#2F80ED"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 19.103 9.45276)",
    fill: "#2F80ED"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12514,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37798e-08 1 1 4.36431e-08 9.55127 0.0307007)",
    fill: "#2F80ED"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12514,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37797e-08 1 1 4.36431e-08 19.103 0.0307007)",
    fill: "#2F80ED"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 9.55127 18.8748)",
    fill: "#2F80ED"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 19.103 18.8748)",
    fill: "#2F80ED"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 191.027 9.45276)",
    fill: "#2F80ED"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 200.578 9.45276)",
    fill: "#2F80ED"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 210.129 9.45276)",
    fill: "#2F80ED"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 219.681 9.45276)",
    fill: "#2F80ED"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 229.232 9.45276)",
    fill: "#2F80ED"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 257.886 9.45276)",
    fill: "#2F80ED"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 238.784 9.45276)",
    fill: "#2F80ED"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 267.438 9.45276)",
    fill: "#2F80ED"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 248.335 9.45276)",
    fill: "#2F80ED"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 276.989 9.45276)",
    fill: "#2F80ED"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 191.027 18.8748)",
    fill: "#2F80ED"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 200.578 18.8748)",
    fill: "#2F80ED"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 210.129 18.8748)",
    fill: "#2F80ED"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 219.681 18.8748)",
    fill: "#2F80ED"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 229.232 18.8748)",
    fill: "#2F80ED"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 257.886 18.8748)",
    fill: "#2F80ED"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 238.784 18.8748)",
    fill: "#2F80ED"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 267.438 18.8748)",
    fill: "#2F80ED"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 248.335 18.8748)",
    fill: "#2F80ED"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 276.989 18.8748)",
    fill: "#2F80ED"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 286.541 9.45276)",
    fill: "#2F80ED"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 296.092 9.45276)",
    fill: "#2F80ED"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 305.643 9.45276)",
    fill: "#2F80ED"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 315.194 9.45276)",
    fill: "#2F80ED"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 286.541 18.8748)",
    fill: "#2F80ED"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 296.092 18.8748)",
    fill: "#2F80ED"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 305.643 18.8748)",
    fill: "#2F80ED"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12515,
    height: 6.12515,
    rx: 3.06257,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 315.194 18.8748)",
    fill: "#2F80ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.fcb67858.svg";
export { ForwardRef as ReactComponent };